import { observer } from 'mobx-react-lite';
import * as React from 'react';

import AuthPending from 'components/shared/auth/AuthPending';
import { AnyObject } from 'types/UtilityTypes';
import { hasTokens, setTokens } from 'utils/authTokens';
import { callNative, MOBILE_AUTH_REQUIRED_EVENT } from 'utils/nativeBridge';
import { isMobileWebView } from 'utils/nativeEnv';

/** HOC проверяет токены в local storage для мобильного приложения */
export const withMobileAuth = <P extends AnyObject>(Component: React.ComponentType<P>) =>
  observer((props: P) => {
    const [isHasTokens, setIsHasTokens] = React.useState(() => {
      if (!isMobileWebView()) {
        return true;
      }

      return hasTokens();
    });

    React.useEffect(() => {
      if (!isHasTokens) {
        callNative('authRequired');
      }
    }, [isHasTokens]);

    React.useEffect(() => {
      window.onTokenRefreshed = (accessToken: string, refreshToken: string) => {
        // eslint-disable-next-line no-console
        console.log('[onTokenRefreshed]', accessToken, refreshToken);
        setTokens({ accessToken, refreshToken });
        setIsHasTokens(true);
      };

      // eslint-disable-next-line no-console
      console.log('[onTokenRefreshed] registered:', typeof window.onTokenRefreshed);

      const handleAuthRequired = () => {
        setIsHasTokens(false);
      };

      document.addEventListener(MOBILE_AUTH_REQUIRED_EVENT, handleAuthRequired);

      return () => {
        document.removeEventListener(MOBILE_AUTH_REQUIRED_EVENT, handleAuthRequired);
        delete window.onTokenRefreshed;
        // eslint-disable-next-line no-console
        console.log('[onTokenRefreshed] removed');
      };
    }, []);

    if (!isHasTokens) {
      return <AuthPending />;
    }

    return <Component {...props} />;
  });
